var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKcLogoMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 855,
    height: 626,
    viewBox: "0 0 855 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.988 482.461H592.365L690.957 312.752L592.365 142.235H395.988L298.203 312.752L395.988 482.461Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2265 0H0V625.497H62.2265V0Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.786 0H477.601L442.043 62.2265H639.228L783.885 312.749L639.228 563.271H442.043L477.601 625.497H674.786L855.001 312.749L674.786 0Z",
    fill: "#292929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.484 624.689L205.269 312.749L385.484 0H313.56L133.344 312.749L313.56 624.689H385.484Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcLogoMarkDark);
export default __webpack_public_path__ + "static/media/kc-logo-mark-dark.237b38fac19daa2c996414b737043c0d.svg";
export { ForwardRef as ReactComponent };